import Qrcode from './qrcode'

export default Qrcode
